/**
 * API client for pot periods endpoints
 */

import { apiClient } from '../../../shared/api/axiosClient';

export interface PotPeriodSummaryDto {
  id: string;
  year: number;
  weekNumber: number;
  periodStart: string;
  periodEnd: string;
  bookInByDeadline: string;
  verifyByDeadline: string;
  submitByDeadline: string;
  potCount: number;
  totalAmount: number;
  displayLabel: string;
}

export interface GetPotPeriodsResponse {
  year: number;
  currentPeriod: PotPeriodSummaryDto | null;
  periods: PotPeriodSummaryDto[];
  hasMoreYears: boolean;
}

export interface GetPotPeriodsOptions {
  year?: number;
  yearsToLoad?: number;
  includeEmpty?: boolean;
}

export async function getPotPeriods(
  options: GetPotPeriodsOptions = {}
): Promise<GetPotPeriodsResponse> {
  const params = new URLSearchParams();
  if (options.year !== undefined) {
    params.set('year', options.year.toString());
  }
  if (options.yearsToLoad !== undefined) {
    params.set('yearsToLoad', options.yearsToLoad.toString());
  }
  if (options.includeEmpty !== undefined) {
    params.set('includeEmpty', options.includeEmpty.toString());
  }
  const queryString = params.toString();
  const url = queryString
    ? `/api/v1/pot-periods?${queryString}`
    : '/api/v1/pot-periods';
  const response = await apiClient.get<GetPotPeriodsResponse>(url);
  return response.data;
}
